module.exports = __webpack_public_path__ + "img/logo_decathlon.b7c04b63.svg";